export const useSxStyles = () => {
  return {
    inputTableItem: {
      display: 'flex',
      alignItems: 'center',
    },
    input: {
      width: '350px',
      float: 'left',
      padding: '3px 6px',
      border: '1px solid #ccc',
      borderRadius: '4px',
      fontSize: '13px',
    },
    errorMsg: {
      width: '350px',
      float: 'left',
      padding: '3px 6px',
      border: '1px solid #d43f3a',
      borderRadius: '4px',
      fontSize: '13px',
    },
    errorMsgSelect: {
      border: '1px solid #d43f3a',
    },
    errorMsgText: {
      width: '350px',
      float: 'left',
      padding: '3px 6px',
      color: '#d43f3a',
      fontSize: '13px',
      fontWeight: 'normal',
    },
    label: {
      fontWeight: 'bold',
      float: 'left',
      padding: '2px',
      color: '#000000',
      fontSize: '13px',
    },
    required: {
      width: '6px',
      height: '6px',
      background: '#d9534f',
      display: 'inline-block',
      margin: '4px 4px 0 4px',
      borderRadius: '3px',
    },
    tableEdit: {
      color: '#000000',
      marginTop: '10px',
    },
  };
};
